import {putMethod} from '@/api'

async function put(processId, request) {
    return await putMethod('/api/travellerData', request)
}

export {put}
